import { createTheme } from '@mui/material/styles';

// Specifically for Material-UI components
// Create base theme first
const baseTheme = {
  palette: {
    mode: 'dark',
    primary: {
      main: '#98FB98',
    },
    secondary: {
      main: '#2196F3',
    },
    error: {
      main: '#F44336',
    },
    background: {
      default: '#000000',
      paper: '#2C2C2C',
    },
    text: {
      primary: '#FFFFFF',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
  },
  typography: {
    fontFamily: "'Montserrat', sans-serif",
    h6: {
      color: '#98FB98',
      fontWeight: 600,
    },
    button: {
      textTransform: 'uppercase',
    },
    h1: {
      fontSize: '24px',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
    },
    body1: {
      fontSize: '14px',
      fontWeight: 400,
      letterSpacing: '0.02em',
    },
  },
};

// Create the theme with proper spacing and transitions
export const theme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: '#98FB98',
    },
    secondary: {
      main: '#2196F3',
    },
    error: {
      main: '#F44336',
    },
    background: {
      default: '#000000',
      paper: '#2C2C2C',
    },
    text: {
      primary: '#FFFFFF',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
  },
  spacing: (factor) => `${8 * factor}px`, // MUI expects a function that returns spacing values
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  transitions: {
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195,
    },
    easing: {
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
      easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
      easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
      sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
    },
  },
  typography: {
    fontFamily: "'Montserrat', sans-serif",
    h6: {
      color: '#98FB98',
      fontWeight: 600,
    },
    button: {
      textTransform: 'uppercase',
    },
    // MUI specific typography settings
    h1: {
      fontSize: '24px',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
    },
    body1: {
      fontSize: '14px',
      fontWeight: 400,
      letterSpacing: '0.02em',
    },
  },
  components: {
    // MUI component customizations
    MuiTableContainer: {
      styleOverrides: {
        root: {
          backgroundColor: '#2C2C2C',
          boxShadow: 'none',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          marginTop: '16px',
        }
      }
    },
    MuiTable: {
      styleOverrides: {
        root: {
          backgroundColor: '#2C2C2C',
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#1C1C1C',
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderColor: 'rgba(255, 255, 255, 0.1)',
          padding: '8px 16px',
          fontSize: '0.85rem',
          textTransform: 'uppercase',
          color: '#FFFFFF',
        },
        head: {
          fontWeight: 600,
          backgroundColor: '#1C1C1C',
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'rgba(152, 251, 152, 0.05)',
          },
          '&:last-child td': {
            borderBottom: 0,
          },
          // Style for completed/printed items
          '&.completed td': {
            textDecoration: 'line-through',
            color: 'rgba(255, 255, 255, 0.5)',
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#2C2C2C',
          borderRadius: 0,
        }
      }
    },
  }
}); 